function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 1.23a6.77 6.77 0 100 13.54A6.77 6.77 0 008 1.23zM0 8a8 8 0 1116 0A8 8 0 010 8zm10.897-2.076c.24.24.24.63 0 .87l-3.282 3.282c-.24.24-.63.24-.87 0l-1.642-1.64a.615.615 0 01.87-.871L7.18 8.77l2.847-2.847c.24-.24.63-.24.87 0z",
  fill: "#2D2D2D"
});
function SvgCirculoconcheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Circulo con check.svg";
export { SvgCirculoconcheck as ReactComponent };